module.exports = __webpack_public_path__ + "static/media/studio.c28ae851.jpg";